export const isEnvironment = (env: string) => {
  return process.env.REACT_APP_ENV === env;
};
